import { Loader } from "@common/handleErrorAndLoading/Loader";
import Grid from "@material-ui/core/Grid";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { ReactNode } from "react";
import { IError } from "src/itsf/fetch/fetcherUtils";
import "./css/detailsLayout.scss";

interface IParams {
    children: ReactNode;
    error?: IError;
    hasDetails: boolean;
    isLoading: boolean;
}

export const DetailsLayout = (props: IParams) => {
    const { children, error, hasDetails, isLoading } = props;

    return (
        <TableRow className="transaction-details">
            <TableCell colSpan={5}>
                {isLoading && <Loader />}
                {error && (
                    <Typography align="center" color="error">
                        {error.errorMessage}
                    </Typography>
                )}
                {!isLoading && !error && hasDetails && (
                    <Grid container spacing={2}>
                        {children}
                    </Grid>
                )}
            </TableCell>
        </TableRow>
    );
};
